import { useCallback, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [token, setToken] = useState("");

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      return;
    }
    const token = await executeRecaptcha("signup");
    setToken(token);
    return token;
  }, [executeRecaptcha]);

  return {
    handleReCaptchaVerify,
    token,
  };
};

export default useRecaptcha;
